import React, { useState, useEffect, useContext } from 'react';
import BarChartComponent from '../charts/BarChartComponent';
import { get_report_data_for_batch_id } from '../../../api/reportsRequests';
import html2canvas from 'html2canvas';
import PptxGenJS from 'pptxgenjs';
import { Card, CardBody, Col, Row } from 'reactstrap';

import { jsPDF } from 'jspdf';


import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GetAppIcon from '@mui/icons-material/GetApp';
import { styled as mustyled } from '@mui/material/styles';
import { ButtonBase } from '@mui/material';
import sampleSurveyResult from '../../../assets/img/reporting/sample_survey_result.png';
import styled, { keyframes } from 'styled-components';
import NpsReportSummary from './NpsReportSummary';
import PieChartComponent from '../charts/PieChartComponent';
import { BarChartTypes, PieChartTypes } from '../charts/ChartTypes';
import AppBarContext from '../../../context/AppBarContext';




const FeatureImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 15px; // Reduced space
  max-width: 700px;
  min-width: 700px; // Wider for the middle image
  opacity: 0.6;
`;

const StyledCardBody = mustyled(CardBody)`
  padding: 5px; /* Example padding */
  text-align: center; /* Centers text */
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers content horizontally */
  justify-content: center; /* Centers content vertically */
`;

const StyledCard = mustyled(Card)`
  margin: 20px; /* Example padding */

`;

const opacityChange = keyframes`
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.2;
  }
`;

const LoadingScreen = styled.div`

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10; /* Ensure it's above other content */
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */

  img {
    width: 50%; /* Adjust based on your needs */
    height: auto;
    animation: ${opacityChange} 2s infinite; /* Using the keyframes animation */
  }

  p {
    font-weight: bold;
    font-size: 24px; /* Adjust based on your needs */
    margin-top: 20px; /* Space between the image and text */
  }
`;
const NpsReport = ({ batchId }) => {
  const [reportData, setReportData] = useState(null);
  const [executiveSummaryData, setExecutiveSummaryData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // New state to manage loading
  const [loadMessage, setLoadMessage] = useState('Loading report data...'); // New state to manage loading message
  const { setAppBarConfig } = useContext(AppBarContext);

  const getImageSize = (canvas, maxWidth, maxHeight) => {
    const aspectRatio = canvas.width / canvas.height;
    // Calculate the best fit dimensions while maintaining the aspect ratio
    let targetWidth = maxWidth;
    let targetHeight = targetWidth / aspectRatio;
    if (targetHeight > maxHeight) {
      targetHeight = maxHeight;
      targetWidth = targetHeight * aspectRatio;
    }
    return { width: targetWidth, height: targetHeight };
  };
  const captureElementsAndDownloadPDF = () => {
    setIsLoading(true); // Start loading indication
    setLoadMessage('Generating PDF...'); // Update loading message
    // Wrap the PDF generation logic inside setTimeout
    setTimeout(() => {
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4',
      });
      const summaryPromise = html2canvas(document.getElementById('reportSummary')).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const { width, height } = getImageSize(canvas, 300, 500);
        doc.addImage(imgData, 'PNG', 50, 50, width, height);
      });
      // Collect promises to render the pages asynchronously
      const promises = reportData.map((report, index) => {
        const elementId = report.key_id;

        return html2canvas(document.getElementById(elementId)).then(canvas => {
          const imgData = canvas.toDataURL('image/png');

          doc.addPage();

          // Add image to PDF. Adjust these values as necessary
          const { width, height } = getImageSize(canvas, 300, 500);
          doc.addImage(imgData, 'PNG', 50, 50, width, height);
        });
      });

      // When all elements are processed, save the PDF
      Promise.all([...[summaryPromise], ...promises]).then(() => {
        doc.save('Report.pdf');
        setIsLoading(false); // Reset loading state
      }).catch(error => {
        console.error('Error generating PDF:', error);
        setIsLoading(false); // Ensure loading state is reset on error
      });

    }, 0); // Execute immediately in the next event loop, allowing state update to process
  };
  const captureElementsAndDownloadPPT = async (elementIds) => {
    setIsLoading(true); // Initiate loading state immediately
    setLoadMessage('Generating PPT...'); // Update loading message
    // Optionally, breaking the task initiation into the next event loop iteration
    // to give React a chance to update the UI before the heavy operations start
    setTimeout(async () => {
      const pres = new PptxGenJS();

      const task_summary = new Promise((resolve, reject) => {
        const element = document.getElementById('reportSummary');
        if (!element) {
          reject(`Element with ID report_summary not found.`);
          return;
        }
        html2canvas(element).then((canvas) => {
          const image = canvas.toDataURL('image/jpeg', 1.0);

          // Calculate aspect ratio of the captured content
          const aspectRatio = canvas.width / canvas.height;
          const maxWidth = 9; // Maximum width of the image on the slide
          const maxHeight = 5.4; // Maximum height of the image on the slide

          // Calculate the best fit dimensions while maintaining the aspect ratio
          let targetWidth = maxWidth;
          let targetHeight = targetWidth / aspectRatio;
          if (targetHeight > maxHeight) {
            targetHeight = maxHeight;
            targetWidth = targetHeight * aspectRatio;
          }

          const slide = pres.addSlide();
          slide.addImage({ data: image, x: 0.1, y: 0.1, w: targetWidth, h: targetHeight });
          resolve();
        }).catch(reject);

      });

      const tasks = reportData.map((report, index) => {
        const elementId = report.key_id;
        return new Promise((resolve, reject) => {
          const element = document.getElementById(elementId);
          if (!element) {
            reject(`Element with ID ${elementId} not found.`);
            return;
          }

          // Use html2canvas to capture the element, which can be heavy
          html2canvas(element).then((canvas) => {

            const image = canvas.toDataURL('image/jpeg', 1.0);

            // Calculate aspect ratio of the captured content
            const aspectRatio = canvas.width / canvas.height;
            const maxWidth = 9; // Maximum width of the image on the slide
            const maxHeight = 5.4; // Maximum height of the image on the slide

            // Calculate the best fit dimensions while maintaining the aspect ratio
            let targetWidth = maxWidth;
            let targetHeight = targetWidth / aspectRatio;
            if (targetHeight > maxHeight) {
              targetHeight = maxHeight;
              targetWidth = targetHeight * aspectRatio;
            }

            const slide = pres.addSlide();
            slide.addImage({ data: image, x: 0.1, y: 0.1, w: targetWidth, h: targetHeight });

            resolve();
          }).catch(reject);
        });
      });

      // Wait for all tasks, then download the PPT
      Promise.all([...[task_summary], ...tasks]).then(() => {
        pres.writeFile({ fileName: 'ReportPresentation.pptx' }).then(() => {
          setIsLoading(false); // End loading
        });
      }).catch((error) => {
        console.error('Error generating presentation:', error);
        setIsLoading(false); // Handle error, ensure to stop loading even if failed
      });
    }, 0);
  };
  useEffect(() => {
    let isMounted = true; // Flag to track the component's mount status

    const fetchReportData = async (batchId) => {
      try {
        const response = await get_report_data_for_batch_id(batchId);
        if (isMounted) { // Update state only if the component is still mounted
          setExecutiveSummaryData(response.data.executive_summary);
          setReportData(response.data.report_data);
        }
      } catch (error) {
        console.error('Failed to fetch report data:', error);
        if (isMounted) {
          // handle error, e.g., updating state to show an error message
          // ensure you check isMounted state here as well if you're updating any state
        }
      }
      setIsLoading(false); // Ensure loading state is reset after the fetch
    };

    if (batchId) fetchReportData(batchId);

    return () => {
      isMounted = false; // Set flag to false when the component unmounts
    };
  }, [batchId]);
  useEffect(() => {
    setAppBarConfig({
      isLoading: isLoading,
      actions: [
        {
          label: 'Download as PPT',
          onClick: reportData ? captureElementsAndDownloadPPT : null, // Disable if no data
          icon: <GetAppIcon />,
          disabled: !reportData, // Disabled state based on data availability
        },
        {
          label: 'Download as PDF',
          onClick: reportData ? captureElementsAndDownloadPDF : null, // Disable if no data
          icon: <PictureAsPdfIcon />,
          disabled: !reportData, // Disabled state based on data availability
        },
      ],
    });

    return () => {
      // Clean up when reportData changes or component unmounts
      setAppBarConfig({ actions: [] });
    };
  }, [isLoading, reportData, setAppBarConfig]);
  return (
    <Row className='justify-content-center' style={{ margin: '0', padding: '0' }}>
      <Col style={{ margin: '0', padding: '0' }}>
        {isLoading &&
          <Row className='justify-content-center' style={{ margin: '0', padding: '0', height: '100vh' }}>
            <Col style={{ margin: '0', padding: '0' }}>

              <Row style={{ height: '100vh' }}>
                <Col md={7}>
                  <StyledCard className='mb-4' style={{ height: '100vh' }}>
                    <StyledCardBody>
                      <LoadingScreen>
                        <FeatureImage src={sampleSurveyResult} alt='Survey Result Sample' />
                        <p>{loadMessage}</p>
                      </LoadingScreen>
                    </StyledCardBody>
                  </StyledCard>
                </Col>
              </Row>
            </Col>
          </Row>}
        {reportData && <Row style={{ margin: '0', padding: '0' }}>
          <Col style={{ margin: '0', padding: '0' }}>
            {/* Disable button and change text based on isLoading */}

            {/*<AppBar position='static' color='default' elevation={0}*/}
            {/*        style={{ backgroundColor: 'white', margin: '0', padding: '0' }}>*/}
            {/*  <Toolbar variant='dense'>*/}
            {/*    /!* Use IconButton with SlideshowIcon and PictureAsPdfIcon *!/*/}
            {/*    <CustomButtonBase*/}
            {/*      onClick={!isLoading ? captureElementsAndDownloadPPT : null}*/}
            {/*      disabled={isLoading}*/}
            {/*      style={{*/}
            {/*        marginRight: '8px',*/}
            {/*        textAlign: 'center',*/}
            {/*        display: 'inline-flex',*/}
            {/*        flexDirection: 'row',*/}
            {/*        alignItems: 'center',*/}
            {/*      }}>*/}
            {/*      <GetAppIcon />*/}
            {/*      <Typography variant='caption' style={{ marginLeft: 8 }}>Download as PPT</Typography>*/}
            {/*    </CustomButtonBase>*/}

            {/*    <CustomButtonBase*/}
            {/*      onClick={!isLoading ? captureElementsAndDownloadPDF : null}*/}
            {/*      disabled={isLoading}*/}
            {/*      style={{*/}
            {/*        marginRight: '8px',*/}
            {/*        textAlign: 'center',*/}
            {/*        display: 'inline-flex',*/}
            {/*        flexDirection: 'row',*/}
            {/*        alignItems: 'center',*/}
            {/*      }}>*/}
            {/*      <PictureAsPdfIcon />*/}
            {/*      <Typography variant='caption' style={{ marginLeft: 8 }}>Download as PDF</Typography>*/}
            {/*    </CustomButtonBase>*/}
            {/*  </Toolbar>*/}
            {/*</AppBar>*/}
          </Col>
        </Row>}
        {reportData && executiveSummaryData && <Row>
          <Col md={7}>
            <StyledCard id='reportSummary' key='reportSummary' className='mb-4'>
              <StyledCardBody>

                < NpsReportSummary reportData={executiveSummaryData} />
              </StyledCardBody>
            </StyledCard>
            {reportData.map((report, index) => (

              <StyledCard id={report.key_id} key={report.key_id} className='mb-4'>
                <StyledCardBody>
                  <Row>
                    {report.report_data.map((chart, index) => (
                      <Col key={'charts_' + index.toString()}>
                        <h5 style={{ fontSize: '0.8em' }}>{chart.chart_data.title}</h5>
                        {BarChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 &&
                          <BarChartComponent data={chart.chart_data.values} />}
                        {PieChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 && <PieChartComponent
                          data={chart.chart_data.values} />}
                      </Col>
                    ))}
                  </Row>
                </StyledCardBody>
              </StyledCard>

            ))}
          </Col>
        </Row>}
      </Col>
    </Row>
  );
};

export default NpsReport;